import colors from "@/main/style/colors";
import styled from "styled-components";

export const TooltipContent = styled.div`
	display: flex;
	flex-direction: column;
	min-width: 170px;
`;

export const TooltipTitle = styled.strong`
	font-weight: 600;
	margin-bottom: 6px;
	white-space: nowrap;
`;

export const TooltipRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: baseline;
	gap: 1.5rem;
	white-space: nowrap;

	& + & {
		margin-top: 2px;
	}
`;

export const TooltipLabel = styled.span`
	color: ${colors.icon};
`;

export const TooltipValue = styled.span`
	font-weight: 500;
`;
